// extracted by mini-css-extract-plugin
export var nav = "main-navigation-module--nav--f0dc2";
export var navList = "main-navigation-module--nav-list--27f00";